import { gql } from "@apollo/client";

export const CREATE_PROMPT_FRAGMENT = gql`
  mutation CreatePromptFragmentMutation($input: CreatePromptFragmentInput!) {
    createPromptFragment(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_PROMPT_FRAGMENT = gql`
  mutation UpdatePromptFragmentMutation($id: Int!, $input: UpdatePromptFragmentInput!) {
    updatePromptFragment(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_PROMPT_FRAGMENT = gql`
  mutation RemovePromptFragmentMutation($id: Int!) {
    removePromptFragment(id: $id) {
      ok
      error
    }
  }
`;

export const PROMPT_FRAGMENT = gql`
  query PromptFragmentQuery($id: Int!) {
    promptFragment(id: $id) {
      ok
      error
      result {
        id
        code
        name
        promptText
      }
    }
  }
`;

export const PROMPT_FRAGMENTS = gql`
  query PromptFragmentsQuery {
    promptFragments {
      ok
      error
      total
      results {
        id
        code
        name
        promptText
      }
    }
  }
`;
